/**
 * Stream-health lag chip (mockup .lag-tag) — the ONE pill shared by
 * car-list thumbs and the mobile mini player, so the severity language
 * can't drift between surfaces. Color/pulse semantics come from lag.ts.
 */

import React from 'react';

import { cn } from '@/lib/utils';
import { LagInfo, SEVERITY_DOT, SEVERITY_PULSES } from './lag';

export const LagChip: React.FC<{ lag: LagInfo; className?: string }> = ({ lag, className }) => (
  <span
    className={cn(
      'inline-flex items-center gap-1 rounded-[3px] bg-black/80 px-1.5 py-px font-mono text-[9px] font-semibold text-white backdrop-blur-sm',
      className,
    )}
  >
    <span
      className={cn(
        'inline-block h-[5px] w-[5px] rounded-full',
        SEVERITY_DOT[lag.severity],
        SEVERITY_PULSES[lag.severity] && 'animate-pulse',
      )}
    />
    {lag.label}
  </span>
);

export default LagChip;
